import { render, staticRenderFns } from "./settledMarketCard.vue?vue&type=template&id=b0bea986&scoped=true&"
import script from "./settledMarketCard.vue?vue&type=script&lang=js&"
export * from "./settledMarketCard.vue?vue&type=script&lang=js&"
import style0 from "./settledMarketCard.vue?vue&type=style&index=0&id=b0bea986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bea986",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
